'use client';

import { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import { toasterApi } from '@terra/ui-design-system';
import { resolveFindingsBulkConflictToast } from '../../../utils/findingsBulkConflict';

const TOO_MANY_TITLE_KEY = {
  delete: 'tooManyDeleteTitle',
  publish: 'tooManyPublishTitle',
  addToReport: 'tooManyAddToReportTitle',
} as const;

export function useFindingsBulkConflictToast() {
  const tBulkConflict = useTranslations('findingsTab.bulkConflict');

  return useCallback(
    ({
      body,
      tooManyTitleKey,
    }: {
      body: unknown;
      tooManyTitleKey: keyof typeof TOO_MANY_TITLE_KEY;
    }) =>
      toasterApi.error(
        resolveFindingsBulkConflictToast({
          body,
          copy: {
            tooManyTitle: tBulkConflict(TOO_MANY_TITLE_KEY[tooManyTitleKey]),
            tooManyDescription: (values) =>
              tBulkConflict('tooManyDescription', values),
            unsupportedAutoPublishedTitle: tBulkConflict(
              'unsupportedAutoPublishedTitle',
            ),
            unsupportedAutoPublishedDescription: tBulkConflict(
              'unsupportedAutoPublishedDescription',
            ),
            genericFailedTitle: tBulkConflict('genericFailedTitle'),
            genericFailedDescription: tBulkConflict('genericFailedDescription'),
          },
        }),
      ),
    [tBulkConflict],
  );
}
